export default __webpack_public_path__ + "static/media/emoji_greet.a99fd71b.png";